import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  loading:{
    color: "#00205b",
    padding: "20% 0",
    display: "flex",
    justifyContent :"center",
    margin: "auto 0"
  },
  logo: {
    width: "100%",
    padding: "3rem 0 1rem 0",
  },
  selfieStepTwo: {
    width: "320px",
    height: "240px",
    "@media screen and (max-width: 412px)": {
      width: "240px",
      height: "240px",
    },
  },
  paperSelfieStepOne: {
    width: "43%",
    "@media screen and (max-width: 412px)": {
      width: "100%",
    },
  },
  paperDocumentStepOne: {
    width: "43%",
    "@media screen and (max-width: 412px)": {
      width: "100%",
    },
  }
}));
